import * as pubsub from "pubsub-js";

enum IntegrationCredentialsEvents {
	ExchangeLinked = "integrationCredentials.exchangeLinked",
	FileServersLinked = "integrationCredentials.fileServersLinked",
	EnvironmentAppLinked = "integrationCredentials.environmentAppLinked",
	IntegrationFlowAuthenticationLinked = "integrationCredentials.integrationFlowAuthenticationLinked"
}

type Data<T extends IntegrationCredentialsEvents> =
	T extends IntegrationCredentialsEvents.ExchangeLinked ? undefined :
	T extends IntegrationCredentialsEvents.FileServersLinked ? undefined :
	T extends IntegrationCredentialsEvents.EnvironmentAppLinked ? { id: number; } :
	T extends IntegrationCredentialsEvents.IntegrationFlowAuthenticationLinked ? { id: number; } :
	never;

export const subscribe: <T extends IntegrationCredentialsEvents>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends IntegrationCredentialsEvents>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	IntegrationCredentialsEvents
};
